/**
 * Deterministic xorshift32 PRNG. Lives inside sim state so replays reproduce
 * every "random" outcome exactly. Never use Math.random() in the engine.
 */
export class Rng {
  private s: number;

  constructor(seed: number) {
    // Zero state would lock xorshift at zero forever.
    this.s = seed >>> 0 || 0x9e3779b9;
  }

  /** Next uint32. */
  nextU32(): number {
    let x = this.s;
    x ^= x << 13;
    x >>>= 0;
    x ^= x >>> 17;
    x ^= x << 5;
    x >>>= 0;
    this.s = x;
    return x;
  }

  /** Float in [0, 1). */
  next(): number {
    return this.nextU32() / 0x100000000;
  }

  get state(): number {
    return this.s;
  }

  set state(v: number) {
    this.s = v >>> 0 || 0x9e3779b9;
  }
}
